import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { MOBILE_HISTORY_INFO_TYPES } from "../mobileHistoryConstants";
import IconAsset from "../../../../components/icon/IconAsset";
import classNames from "classnames";
import amountFormat from "../../../../utils/amountFormat";
import { useCallback } from "react";
import { setAccountSelectedHistoryInfoAction } from "../../../../modules/Account/accountActions";
import { useDispatch, useSelector } from 'react-redux';
import { LITE_TRADE_POSITION_SIDE } from "../../../../modules/LiteTrade/liteTradeConstants";
import { getLiteTradeAssetsBySymbol } from "../../../../modules/LiteTrade/liteTradeSelectors";
import {
    MobileHistoryRowAmountStyled,
    MobileHistoryRowIconContainerStyled,
    MobileHistoryRowStyled
} from "../styled/MobileHistoryRowStyled";
import { IMobileHistoryPositionRow } from '../mobileHistory.t';
import { locationSlice } from '../../../../modules/Location/locationReducer';
import { LOCATION_NAMES } from '../../../../modules/Location/locationConstants';

interface IMobileHistoryPositionRowProps {
    item: IMobileHistoryPositionRow;
}

function MobileHistoryPositionRow(props: IMobileHistoryPositionRowProps) {
    const {item} = props;
    const {getLangPath} = useLangContext();
    const assetsBySymbol = useSelector(getLiteTradeAssetsBySymbol);
    const asset = assetsBySymbol[item.symbol];
    const isBuy = item.side === LITE_TRADE_POSITION_SIDE.BUY;
    const dispatch = useDispatch();

    const handleRowClick = useCallback(() => {
        dispatch(setAccountSelectedHistoryInfoAction({info: item, type: MOBILE_HISTORY_INFO_TYPES.POSITION}));
        dispatch(locationSlice.actions.openLocationAction({
            name: LOCATION_NAMES.HISTORY_INFO,
            searchParams: { type: MOBILE_HISTORY_INFO_TYPES.POSITION, id: item.position_code },
        }));
    }, [dispatch, item]);

    return <MobileHistoryRowStyled onClick={handleRowClick}>
        <MobileHistoryRowIconContainerStyled>
            <IconAsset symbol={item.symbol}/>
        </MobileHistoryRowIconContainerStyled>
        <div className="flex-1 overflow-hidden">
            <div className="f16 text-truncate">
                {getLangPath(`lite_version.history.${isBuy ? 'bought_asset' : 'sold_asset'}`, {asset: asset?.info?.description})}
            </div>
            <div className="color-white-60">{item.symbol}</div>
        </div>
        <div className="ms-2">
            {
                !!item.pl ? (
                    <MobileHistoryRowAmountStyled className={classNames('f16 text-end', {
                        'negative': parseFloat(item.pl) < 0,
                        'positive': parseFloat(item.pl) > 0,
                    })}>
                        {amountFormat(item.pl, 2, '$')}
                    </MobileHistoryRowAmountStyled>
                ) : <div/>
            }
            <div className="color-white-60 text-end">{item.formattedDate}</div>
        </div>
    </MobileHistoryRowStyled>
}

export default MobileHistoryPositionRow;
